<template>
<div class="ysw">
  <ul>
    <li>周 期</li>
    <li>年增长均值</li>
    <li>眼轴标准均长</li>
    <li>上限均值</li>
  </ul>
  <ul>
    <li>出生第一年</li>
    <li>0.6mm</li>
    <li>16.2mm</li>
    <li>无数据</li>
  </ul>
  <ul>
    <li>1~满2周岁</li>
    <li>0.6mm</li>
    <li>17.7mm</li>
    <li>无数据</li>
  </ul>
  <ul>
    <li>3~满4周岁</li>
    <li>0.5mm</li>
    <li>18.7mm</li>
    <li>20.5mm(参考)</li>
  </ul>
  <ul>
    <li>5~满6周岁</li>
    <li>0.4mm</li>
    <li>19.6mm</li>
    <li>21.1mm</li>
  </ul>
  <ul>
    <li>7~满8周岁</li>
    <li>0.4mm</li>
    <li>20.3mm</li>
    <li>21.5mm</li>
  </ul>
  <ul>
    <li>9~满10周岁</li>
    <li>0.4mm</li>
    <li>21.1mm</li>
    <li>22.0mm</li>
  </ul>
  <ul>
    <li>满11周岁</li>
    <li>0.3~0.4mm</li>
    <li>21.6mm</li>
    <li>22.4mm</li>
  </ul>
  <ul>
    <li>满12周岁</li>
    <li>0.3~0.4mm</li>
    <li>22.0mm</li>
    <li>22.6mm</li>
  </ul>
  <ul>
    <li>满13周岁</li>
    <li>0.3mm</li>
    <li>22.4mm</li>
    <li>22.9mm</li>
  </ul>
  <ul>
    <li>满麺14周岁</li>
    <li>0.3mm</li>
    <li>22.7mm</li>
    <li>23.2mm</li>
  </ul>
  <ul>
    <li>满15周岁</li>
    <li>0.2~0.3mm</li>
    <li>23.0mm</li>
    <li>23.6mm</li>
  </ul>
  <ul>
    <li>满16周岁</li>
    <li>0.2~0.3mm</li>
    <li>23.3mm</li>
    <li>23.9mm</li>
  </ul>
  <ul>
    <li>满17周岁</li>
    <li>0.2mm</li>
    <li>23.5mm</li>
    <li>24.1mm</li>
  </ul>
  <ul>
    <li>满18周岁</li>
    <li>0.2mm</li>
    <li>23.7mm</li>
    <li>24.3mm</li>
  </ul>
  <ul>
    <li>满19周岁</li>
    <li>0.1mm</li>
    <li>23.8mm</li>
    <li>24.3mm</li>
  </ul>
</div>
</template>

<script>
export default {
  name: "ysw",
}
</script>

<style scoped lang="scss">
  ul {
    display: flex;
    justify-content: center;
    border: 1px solid #a5a5a5;
    width: 520px;
    li {
      width: 130px;
      border-right: 1px solid #a5a5a5;
      padding: 5px 0;
    }
    li:nth-child(4) {
      border-right: none;
    }
  }
</style>
